import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from "../../GlobalFiles/Sidebar";

const CommissionPage = () => {
  const { data: { user } } = useSelector((state) => state.auth);
  const isAdmin = user?.userType === 'admin';
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

  if (!isAdmin) {
    return (
      <div className="flex min-h-screen bg-gray-100">
        <Sidebar />
        <div className="flex-1 p-4 md:p-8 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
            <p className="text-gray-600">Only managers can access this page.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex min-h-screen bg-gray-50">
        <Sidebar onCollapse={setSidebarCollapsed} />
        <div className={`flex-1 p-6 transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-0'}`}>

          <div className="p-6 ml-40">
            <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-3 gap-4 bg-gradient-to-r from-sky-600 to-indigo-500 p-6 rounded-lg">
              <h1 className="text-3xl font-bold text-gray-200 flex items-center">
                <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Collection & Commission Reports
              </h1>
            </div>

            <h1 className="text-3xl font-bold text-gray-900 my-2 mt-5">Commission</h1>
            {/* <p className="text-gray-600 mb-6">Choose a report to view commission details.</p> */}

            <div className="grid grid-cols-2 sm:grid-cols-2 gap-4">
              <Link to="/daily-commission" className="block">
                <div className="flex flex-col items-center justify-center gap-2 p-3 bg-white rounded-lg shadow hover:shadow-md transition h-24 text-center">
                  <div className="w-10 h-10 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <h3 className="text-sm font-medium text-gray-900">Daily Commission</h3>
                </div>
              </Link>

              <Link to="/monthly-commission" className="block">
                <div className="flex flex-col items-center justify-center gap-2 p-3 bg-white rounded-lg shadow hover:shadow-md transition h-24 text-center">
                  <div className="w-10 h-10 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-green-400 to-blue-600">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16v16H4z" />
                      <path d="M4 10h16" />
                      <path d="M10 4v6" />
                    </svg>
                  </div>
                  <h3 className="text-sm font-medium text-gray-900">Monthly Commission</h3>
                </div>
              </Link>
            </div>

            <hr className="my-6 border-gray-300" />
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Collection</h1>

            <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-3 gap-4">
              <Link to="/daily-collection" className="block">
                <div className="flex flex-col items-center justify-center gap-2 p-3 bg-white rounded-lg shadow hover:shadow-md transition h-24 text-center">
                  <div className="w-10 h-10 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-indigo-500 to-indigo-200">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <h3 className="text-sm font-medium text-gray-900">Daily Collection</h3>
                </div>
              </Link>

              <Link to="/daily-collection-short" className="block">
                <div className="flex flex-col items-center justify-center gap-2 p-3 bg-white rounded-lg shadow hover:shadow-md transition h-24 text-center">
                  <div className="w-10 h-10 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-indigo-500 to-indigo-200">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <h3 className="text-sm font-medium text-gray-900">Daily Collection Short</h3>
                </div>
              </Link>

              <Link to="/monthly-collection" className="block">
                <div className="flex flex-col items-center justify-center gap-2 p-3 bg-white rounded-lg shadow hover:shadow-md transition h-24 text-center">
                  <div className="w-10 h-10 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-amber-400 to-amber-600">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16v16H4z" />
                      <path d="M4 10h16" />
                      <path d="M10 4v6" />
                    </svg>
                  </div>
                  <h3 className="text-sm font-medium text-gray-900">Monthly Collection</h3>
                </div>
              </Link>

              <Link to="/monthly-collection-short" className="block">
                <div className="flex flex-col items-center justify-center gap-2 p-3 bg-white rounded-lg shadow hover:shadow-md transition h-24 text-center">
                  <div className="w-10 h-10 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-green-400 to-red-600">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16v16H4z" />
                      <path d="M4 10h16" />
                      <path d="M10 4v6" />
                    </svg>
                  </div>
                  <h3 className="text-sm font-medium text-gray-900">Monthly Collection Short</h3>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommissionPage;